module.exports = __webpack_public_path__ + "static/b2-e7f8c2d5929717061cb9d50d6ca26484.jpg";